import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { DefaultRequestBodyType } from "../../../constant/document";
import { del, get, patch, post } from "../../../services/API/ApiClient";
import { OrganizationDetailResponseType } from "../../../utils/type";
import { openErrorNotification, openNotification } from "../../../components/Template/NotificationComponent";
import { autoRefreshFrequency } from "../../../constant/constant";

export const fetchOrganizations = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchOrganizations", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().OrganizationsPageState.currentRequestBody,
    };
    dispatch(updateOrganizationsRequestBody(reqBody));
    //response return
    const response = await post("/tenants/search", "Transcribe", reqBody);
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Infinite Scrolling
export const fetchPaginateOrganizations = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchPaginateOrganizations", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const reqBody = {
      ...getState().OrganizationsPageState.currentRequestBody,
      PageNum: getState().OrganizationsPageState.pagination.page,
    };
    const response = await post("/tenants/search", "Transcribe", reqBody);
    return response.data.results;
    //response return
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Search Organziations
export const searchOrganizations = createAsyncThunk<any, { searchKeyword: string }, { state: RootState }>("transcribe/searchOrganizations", async (args, { getState, dispatch }) => {
  dispatch(resetOrganizationsTable());
  dispatch(
    updateOrganizationsRequestBody({
      ...getState().OrganizationsPageState.currentRequestBody,
      Keyword: args.searchKeyword,
    })
  );
  dispatch(fetchOrganizations({}));
});

//Fetching the RefreshOrganziations
export const fetchRefreshOrganizations = createAsyncThunk<any, any, { state: RootState }>("transcribe/fetchRefreshOrganizations", async (args, { getState, dispatch, rejectWithValue }) => {
  const currentDataLength = getState().OrganizationsPageState.data.length === 0 ? 30 : getState().OrganizationsPageState.data.length;
  try {
    const reqBody = {
      ...getState().OrganizationsPageState.currentRequestBody,
      pageSize: Math.ceil(currentDataLength / 30) * 30,
    };
    const response = await post("/tenants/search", "Transcribe", reqBody);
    return response.data.results;
    //response return
  } catch (e) {
    return rejectWithValue(e);
  }
});

//Auto Refreshing the Organizations
export const autoRefreshOrganizations = createAsyncThunk<any, any, { state: RootState }>("transcribe/autoRefreshOrganziations", async (args, { getState, dispatch, rejectWithValue }) => {
  if (getState().OrganizationsPageState.autoRefreshOrganizationState.currentIntervalId) {
    clearInterval(getState().OrganizationsPageState.autoRefreshOrganizationState.currentIntervalId);
  }
  if (getState().OrganizationsPageState.autoRefreshOrganizationState.autoRefresh) {
    const intervalId = setInterval(() => {
      dispatch(fetchRefreshOrganizations({}));
    }, autoRefreshFrequency);
    dispatch(setOrganizationsAutoRefresh({ intervalId }));
  }
});

export const switchOnOrganization = createAsyncThunk<any, any, { state: RootState }>("transcribe/switchOnOrganization", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await patch(`/tenants/${args.id}/enable-tenant`, "Transcribe", {});
    openNotification("Enable Organization", "Organization enabled successfully", "top");

    return response.data.results;
  } catch (e) {
    openErrorNotification("Enable Organization", "Error enabling organization, please try again.", "top");
    return rejectWithValue(e);
  }
});
export const switchOffOrganization = createAsyncThunk<any, any, { state: RootState }>("transcribe/switchOffOrganization", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await patch(`/tenants/${args.id}/disable-tenant`, "Transcribe", {});
    openNotification("Disable Organization", "Organization disabled successfully", "top");

    return response.data.results;
  } catch (e) {
    openErrorNotification("Disable Organization", "Error disabling organization, please try again.", "top");
    return rejectWithValue(e);
  }
});
export const createOrganizations = createAsyncThunk<any, any, { state: RootState }>("transcribe/createOrganizations", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await post("/tenants", "Transcribe", args);
    openNotification("Create Organization", "Organization created successfully", "top");
    dispatch(fetchOrganizations({}));

    return response.data.results;
  } catch (e) {
    openErrorNotification("Create Organization", "Error creating organization, please try again.", "top");
    return rejectWithValue(e);
  }
});

export const deleteOrganizations = createAsyncThunk<any, any, { state: RootState }>("transcribe/deleteOrganizations", async (args, { getState, dispatch, rejectWithValue }) => {
  try {
    const response = await del(`/tenants/${args}`, "Transcribe");
    dispatch(fetchOrganizations({}));
    return response.data.results;
  } catch (e) {
    return rejectWithValue(e);
  }
});

// Start the generic actions for Organizations
export const updateOrganizationsRequestBody = createAction<DefaultRequestBodyType>("transcribe/updateOrganizationsRequestBody");
export const resetOrganizationsTable = createAction("transcribe/resetOrganizationsTable");
export const setOrganizationsAutoRefresh = createAction<{ intervalId: NodeJS.Timer }>("transcribe/setOrganizationsAutoRefresh");
export const switchOrganizationsAutoFresh = createAction<{ autoRefresh: boolean }>("transcribe/switchOrganizationsAutoFresh");
export const stopOrganizationsAutoRefresh = createAction("transcribe/stopOrganizationsAutoRefresh");
export const setCurrentRecord = createAction<any>("transcribe/setCurrentRecord");
// End the generic actions for Organizations

//Modal
export const openCreateOrganizationsModal = createAction("transcribe/openCreateOrganizationsModal");
export const closeCreateOrganizationsModal = createAction("transcribe/closeCreateOrganizationsModal");
export const openDeleteOrganizationsModal = createAction("transcribe/openDeleteOrganizationsModal");
export const closeDeleteOrganizationsModal = createAction("transcribe/closeDeleteOrganizationsModal");
export const openTemplateModal = createAction("transcribe/openTemplateModal");
export const closeTemplateModal = createAction("transcribe/closeTemplateModal");
